// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import { Duration } from '@zapier/theme';
import { Timeout } from '@zapier/common-components';

const TooltipHover = createReactClass({
  displayName: 'TooltipHover',

  propTypes: {
    onEnter: PropTypes.func.isRequired,
    onLeave: PropTypes.func.isRequired,
    delay: PropTypes.number.isRequired,
    children: PropTypes.any,
  },

  getDefaultProps() {
    return {
      delay: Duration.tooltipTimeout.default,
    };
  },

  getInitialState() {
    return {
      isHovering: false,
      isActive: false,
    };
  },

  onMouseEnter() {
    this.setState({
      isHovering: true,
    });
  },

  onMouseLeave() {
    this.props.onLeave();
    this.setState({
      isActive: false,
      isHovering: false,
    });
  },

  onDoneWaiting() {
    this.props.onEnter();
    this.setState({
      isActive: true,
    });
  },

  render() {
    return (
      // This can't really be accessible since the whole point is to handle
      // hover. onFocus/onBlur won't really work because we can't make this
      // focusable, so that has to be handled outside this component.
      <div // eslint-disable-line jsx-a11y/no-static-element-interactions
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        {this.props.children}
        <Timeout
          delay={this.props.delay}
          isWaiting={this.state.isHovering}
          onTimeout={this.onDoneWaiting}
        />
      </div>
    );
  },
});

export default TooltipHover;
